<div class="w-full h-full">
    @if (loading()) {
        <div class="w-full h-full bg-dat-grey-200 animate-pulse" data-testid="iq-rate-ntl-card-loader"></div>
    } @else if(nationalData()?.national?.rates?.mile?.[0].average > 0) {
        <section
            class="flex justify-between items-baseline"
            [attr.data-testid]="id + '-body'"
            [attr.data-styletarget]="'iq-rate-ntl-card__body'"
        >
            <section
                [attr.data-styletarget]="
                    'iq-rate-ntl-card__container--rate'
                "
            >
                <label
                    [datiqTemplateMd]="rate()"
                    [attr.data-testid]="id + '-rate'"
                    [attr.data-styletarget]="'iq-rate-ntl-card-rate'"
                ></label>
            </section>
            <section
                class="font-body-2 text-dat-grey-500 flex items-end"
                [attr.data-styletarget]="
                    'iq-rate-ntl-card__container--trend'
                "
            >
                <label
                    [datiqTemplateMd]="trend()"
                    [attr.data-testid]="id + '-trend'"
                    [attr.data-styletarget]="'iq-rate-ntl-card-trend'"
                ></label>
            </section>
        </section>
    } @else {
        <!-- Change Error To Not Use Component -->
        <datiq-screen-error>
            <div
                datiq-screen-error-message-title
                [attr.data-testid]="'iq-rate-ntl-card-empty-title'"
            >
                Rate is currently unavailable.
            </div>
            <div
                datiq-screen-error-message-content
                [attr.data-testid]="'iq-rate-ntl-card-empty-content'"
            >
                Refresh or try again later.
            </div>
        </datiq-screen-error>
    }
</div>
